import { theme } from "../../utils/theme";

export const styles = {
  item: {
    alignItems: { xs: "start", sm: "start" },
    backgroundColor: theme.palette.grays.white,
    border: `solid 1px ${theme.palette.grays[100]}`,
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    gap: { xs: 8, md: 20 },
    height: { xs: "80vh", md: "58vh" },
  },
  itemContentBody: {
    color: theme.palette.grays[700],
    fontSize: {
      xs: theme.typography.body2,
      md: theme.typography.body,
    },
    fontWeight: 300,
    letterSpacing: 1.2,
    lineHeight: { xs: 1.3, md: 1.5 },
  },
  itemContentContainer: {
    alignItems: { xs: "start", md: "start" },
    gap: { xs: 4, md: 8 },
    height: "100%",
    justifyContent: { xs: "start", md: "center" },
    px: { xs: 4, md: 4 },
    py: { xs: 4, md: 4 },
    width: { xs: "100%", md: "40%" },
  },
  itemContentHeader: {
    color: theme.palette.grays["black"],
    fontSize: {
      xs: theme.typography.h2,
      md: theme.typography.h1,
    },
    fontWeight: 600,
    letterSpacing: 1.2,
    lineHeight: 1.2,
    textTransform: "capitalize",
  },
  grow: {
    flexGrow: 1,
    marginLeft: "auto",
  },
  margin: {
    display: "flex",
    margin: 1,
  },
};
